import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap pre-renderiza apenas a rota '/'. Pra outras rotas, o HTML
// servido pela Netlify (SPA fallback) é da LP — se hidratarmos, o React
// tenta casar com a tela errada e da hydration mismatch (#418).
// Solucao: hidrata apenas quando a URL atual eh a rota pre-renderizada;
// nas outras, limpa o DOM e renderiza do zero.
const isPrerenderedRoute = window.location.pathname === '/';

if (isPrerenderedRoute && container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  if (container.hasChildNodes()) container.innerHTML = '';
  createRoot(container).render(tree);
}


